<template>
    <div>
        <h2><router-link :to="{ name: 'pos' }">รายการขาย POS</router-link> > เลือกสาขา POS</h2>

        <v-container fluid>
          <v-row>
            <v-col
              v-for="(device, index) in devices"
              :key="device.id"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card height="100%" min-height="250">
                <v-card-text class="text-h5">{{ device.name }}</v-card-text>
                <v-card-text>{{ device.branch }}</v-card-text>
                <v-card-text>{{ device.fullAddress }}</v-card-text>

                <v-card-actions>
                  <v-btn plain color="primary" @click="$router.push({name: 'posorder_create', params: { device_id: device.id  }})">
                    <v-icon size="40" class="mr-4">
                      {{ icons.mdiPointOfSale }}
                    </v-icon>
                    เปิด POS
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="$store.getters['auth/GET_ABILITY'].can('update', 'POSSetting')"
            >
              <v-card height="100%" min-height="250">
                <v-card-text class="d-flex flex-column align-center justify-center" style="height: 100%">
                  <div>
                    <v-icon size="40" class="mr-4" color="primary">
                      {{ icons.mdiPointOfSale }}
                    </v-icon>
                  </div>
                  <div class="mt-2">
                    <v-btn
                      color="primary"
                      class="ml-auto"
                      @click="$router.push({ 'name': 'device_create', params: { device_id: 'create' } })"
                    >
                    <v-icon class="mr-2">
                      {{ icons.mdiPlus }}
                    </v-icon>
                    เพิ่มเครื่อง POS</v-btn>
                  </div>
                  <div class="mt-2 mute">
                    สามารถเพิ่มเครื่อง POS ได้ที่นี่
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
    </div>
</template>
<script>
import { Device } from '@/classes/pos/device'
import { asyncGet } from '@/helpers/asyncAxios'
import errorParser from '@/plugins/errorparser'
import { mdiClose, mdiPointOfSale, mdiPlus } from '@mdi/js'
export default {
  data() {
    return {
      devices: [],
      selectedItem: null,
      posModal: false,
      orderListDialog: false,
      icons: {
        mdiClose,
        mdiPointOfSale,
        mdiPlus,
      },
    }
  },
  async created() {
    this.$store.commit('app/SET_GLOBAL_LOADING', true)

    try {
      const response = await asyncGet('/pos/devices')

      this.devices = response.map(item => new Device(item))
    } catch (error) {
      this.$root.showCommonDialog('มีปัญหา', errorParser(error))
    }
    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
}
</script>
